import { useContext, useMemo } from 'react';
import { XrayPanelContext } from './XrayPanelContext';
export const emptyStandaloneTracker = {
  track: () => {}
};
export const useClonedTracker = tracker => {
  return useMemo(() => {
    if (!tracker) {
      return emptyStandaloneTracker;
    }
    return tracker.clone({
      standalone: true
    });
  }, [tracker]);
};
export const useTracker = () => {
  const {
    standaloneTracker
  } = useContext(XrayPanelContext);
  return standaloneTracker !== null && standaloneTracker !== void 0 ? standaloneTracker : emptyStandaloneTracker;
};
export const useStandaloneTracker = () => useTracker();